import { Severity } from '../../shared/enums/severity';
import { DisplayMessage } from './display-message';

export class DisplayMessages {
  severity: Severity = Severity.Success;
  messages: DisplayMessage[] = [];

  public addMessage(message: DisplayMessage) {
    this.messages.push(message);
    if (message.severity > Severity[this.severity]) {
      this.severity = Severity[message.severity];
    }
  }
}
